// extracted by mini-css-extract-plugin
export default {"wrapper":"XC-z","viewport":"YC-z","container":"ZC-z","slide":"_C-z"};